export * from '@primeuix/themes/aura/progressspinner';
export { default } from '@primeuix/themes/aura/progressspinner';
